import assets from "../../assets";
import useHandler from "./handler";
import "./styles.sass";

export const InfoSuccess = () => {
  const { pathRes, navigate, goToDashboard } = useHandler();
  const targetExams = ["JEE Advanced", "JEE Main"];

  const profile = {
    grade: "12th Grade",
    board: "CBSE",
    medium: "English",
    age: "18-24",
    institution: "Delhi Public School",
  };

  return (
    <section className="info_success">
      <section className="info_success_card">
        <div className="info_success_icon">
          <img src={assets.ic_info_success} alt="ic_info_success" />
        </div>

        <h2>Your personalized learning path is ready</h2>

        <p>
          Here's a summary of what you've selected. We'll use this to tailor
          your courses and practice materials.
        </p>

        {/* Target Exams */}
        <section className="info_sucesss_summary_card">
          <h4>🎓 Target Exams</h4>

          <div className="info_sucesss_exam_grid">
            {(pathRes?.target_exams || targetExams).map((exam) => (
              <div className="info_sucesss_exam_item" key={exam}>
                <div className="info_sucesss_exam_icon">📘</div>

                <div>
                  <strong>{exam}</strong>
                  
                  {/* <small>Engineering Entrance</small> */}
                </div>
               
              </div>
            ))}
          </div>
        </section>

        {/* Personal Profile */}
        <section className="info_sucesss_summary_card">
          <h4>👤 Personal Profile</h4>

          <div className="info_sucesss_profile_grid">
            <div>
              <label>Grade / Class</label>
              <span>{pathRes?.personal_profile?.class_grade || "-"}</span>
            </div>

            <div>
              <label>Board</label>
              <span>{pathRes?.personal_profile?.board || "-"}</span>
            </div>

            <div>
              <label>Medium</label>
              <span>
                {pathRes?.personal_profile?.medium_of_instruction || "-"}
              </span>
            </div>

            <div>
              <label>Age</label>
              <span>{pathRes?.personal_profile?.age || "-"}</span>
            </div>

            <div className="info_sucesss_full_width">
              <label>Institution</label>
              <span>{pathRes?.personal_profile?.institution_name || "-"}</span>
            </div>
          </div>
        </section>

        <button className="info_sucesss_dashboard_btn" onClick={goToDashboard}>
          Go to Dashboard
        </button>
      </section>
    </section>
  );
};
